/* eslint-disable react/display-name */
import { useSearchParams } from '@ksyos/router';

// Higher order component neccesary to use useSearchParams hook in class components
export const withSearchParams = (Component: any) => {
    return (props: any) => {
        const [searchParams] = useSearchParams();

        return (
            <Component
                searchParams={searchParams}
                {...props}
            />
        );
    };
};
